import React, { Component } from 'react';
import classnames from 'classnames';
import Iconc from 'components/Iconc';
import Inputc from 'components/Inputc';
import axios from 'axios';
import { Checkbox, Icon } from 'antd';
import './index.styl';

const clzpre = 'ssfe-monitor';

const { Search } = Inputc;

// const testData = [
//     {
//         'url': 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D77680435/1.live',
//         'accessToken': 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
//     },
//     {
//         'url': 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72554725/1.live',
//         'accessToken': 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
//     },
//     {
//         'url': 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765205/1.live',
//         'accessToken': 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
//     },
//     {
//         'url': 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72764251/1.live',
//         'accessToken': 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
//     },
//     {
//         'url': 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765203/1.live',
//         'accessToken': 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
//     },
//     {
//         'url': 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765194/1.live',
//         'accessToken': 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
//     },
//     {
//         'url': 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72554725/1.live',
//         'accessToken': 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
//     }
// ];

class Monitor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeSize: 'nine',
            deviceList: [],
            selectedDeviceId: [],
            searchText: ''
        };
        this.deviceKeyObj = {};
        this.sizeObj = {
            one: 1,
            four: 4,
            nine: 9
        };
        this.testData = [
            {
                id: '1',
                deviceName: '设备一',
                isOnline: true,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D77680435/1.live',
                    accessToken: 'at.13rmd17a3vqfrdvs5qgx6uj47iygdcew-9gumxj4pjy-10rez1q-th32ks5gv'
                }
            },
            {
                id: '2',
                deviceName: '设备二',
                isOnline: true,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72554725/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            },
            {
                id: '3',
                deviceName: '设备三',
                isOnline: false,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765205/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            },
            {
                id: '4',
                deviceName: '设备四',
                isOnline: true,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72764251/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            },
            {
                id: '5',
                deviceName: '设备五',
                isOnline: false,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765203/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            },
            {
                id: '6',
                deviceName: '设备六',
                isOnline: true,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765194/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            },
            {
                id: '7',
                deviceName: '设备七',
                isOnline: true,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765194/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            },
            {
                id: '8',
                deviceName: '设备八',
                isOnline: true,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765194/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            },
            {
                id: '9',
                deviceName: '设备九',
                isOnline: true,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765194/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            },
            {
                id: '10',
                deviceName: '设备十',
                isOnline: true,
                mediaData: {
                    url: 'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/D72765194/1.live',
                    accessToken: 'at.9vgkdt9247kmfpqgatysny8g5453exi0-1sd3g1fqx0-0bagd0y-d1dx9zxuh'
                }
            }
        ];
        this.rightOperationArr = [
            {
                title: '缩放',
                key: 'zoom',
                operation: ['plus', 'minus']
            },
            {
                title: '光圈',
                key: 'aperture',
                operation: ['plus', 'minus']
            },
            {
                title: '焦距',
                key: 'focalDistance',
                operation: ['plus', 'minus']
            }
        ];
        this.rightBtnArr = [
            {
                key: 'one',
                type: 'one-square'
            },
            {
                key: 'four',
                type: 'four-square'
            },
            {
                key: 'nine',
                type: 'nine-square'
            }
        ];
    }

    componentDidMount() {
        this.getDeviceData();
    }

    getDeviceData = () => {
        axios.get('/zhgd/index/monitor?pageNo=1&pageSize=100').then(data => {
            this.handleGetDeviceList(data.result || []);
        });
    };

    handleGetDeviceList = result => {
        const obj = {};
        (result || []).forEach(item => {
            obj[item.id] = `${new Date().getTime().toString()}-${item.id}`;
        });
        this.deviceKeyObj = obj;
        const defaultSelect = (result || []).slice(0, 9).map(item => item.id);
        this.setState({
            deviceList: result || [],
            selectedDeviceId: defaultSelect
        });
    };

    getIframeDom = () => {
        const dom = [];
        const { activeSize, deviceList, selectedDeviceId } = this.state;
        const displayData = (deviceList || []).filter(item => selectedDeviceId.indexOf(item.id) !== -1);
        const pageSize = this.sizeObj[activeSize] || 9;
        /* let singleWidth = '33%';
        switch (pageSize) {
            case 9:
            default:
                singleWidth = '33%';
                break;
            case 4:
                singleWidth = '25%';
                break;
            case 1:
                singleWidth = '100%';
                break;
        } */
        for (let i = 0; i < pageSize && i < displayData.length; i++) {
            const mediaData = displayData[i].mediaData || {};
            if (mediaData && mediaData.url && mediaData.accessToken) {
                dom.push(
                    <div className={`singleIframe iframe${pageSize}`} key={this.deviceKeyObj[displayData[i].id]}>
                        <iframe
                            title={`frame${i}`}
                            // width={singleWidth}
                            // height={'291px'}
                            allowFullScreen
                            src={`${mediaData.url}&autoplay=1&accessToken=${mediaData.accessToken}`}
                        ></iframe>
                        <span>{`${displayData[i].deviceName}`}</span>
                    </div>
                );
            }
        }
        return dom;
    };

    handleChangePageSize = type => {
        if (this.state.activeSize !== type) {
            const obj = {};
            Object.keys(this.deviceKeyObj).forEach(item => {
                obj[item] = `${new Date().getTime().toString()}-${item}`;
            });
            this.deviceKeyObj = obj;
            this.setState({
                activeSize: type
            });
        }
    };

    changeDeviceSelect = e => {
        const { selectedDeviceId } = this.state;
        const index = selectedDeviceId.findIndex(item => item === e.target.value);
        if (index !== -1) {
            selectedDeviceId.splice(index, 1);
        } else {
            selectedDeviceId.push(e.target.value);
        }
        this.setState({
            selectedDeviceId: selectedDeviceId
        });
    };

    generateDeviceList = () => {
        const { deviceList, selectedDeviceId, activeSize, searchText } = this.state;
        const pageSize = this.sizeObj[activeSize] || 9;
        let listData = deviceList || [];
        if (searchText) {
            listData = listData.filter(item => (item.deviceName || '').indexOf(searchText) !== -1);
        }
        if ((deviceList || []).length) {
            return listData.map(item => {
                const isDisabled = selectedDeviceId.length >= pageSize && selectedDeviceId.indexOf(item.id) === -1;
                return (
                    <li key={item.id} className={`${item.isOnline ? 'online' : 'offline'} single-device`}>
                        <Iconc type={'jiankong'} className={'device-logo'} />
                        <span className={'name'}>{item.deviceName}</span>
                        <span className={'status'}>{item.isOnline ? '在线' : '离线'}</span>
                        <Checkbox
                            value={item.id}
                            checked={selectedDeviceId.indexOf(item.id) !== -1}
                            disabled={isDisabled}
                            onChange={this.changeDeviceSelect}
                        />
                    </li>
                );
            });
        } else {
            return <div>暂无数据</div>;
        }
    };

    generateRightOperation = () => {
        return this.rightOperationArr.map(item => {
            return (
                <li key={item.key} className={'single-li'}>
                    <span className={'title'}>{item.title}</span>
                    <div className={'operation-li'}>
                        {(item.operation || []).map(operate => {
                            return (
                                <div key={`${item.key}-${operate}`} className={'single-btn'}>
                                    <Icon type={operate} />
                                </div>
                            );
                        })}
                    </div>
                </li>
            );
        });
    };

    generateRightButton = () => {
        return this.rightBtnArr.map(item => {
            return (
                <Iconc
                    key={item.key}
                    type={item.type}
                    onClick={() => {
                        this.handleChangePageSize(item.key);
                    }}
                    className={classnames({ active: this.state.activeSize === item.key })}
                />
            );
        });
    };

    render() {
        return (
            <div className={clzpre}>
                <aside className={'com-bg'}>
                    <Search
                        placeholder={'请输入'}
                        style={{ width: '370px' }}
                        onSearch={val => {
                            this.setState({
                                searchText: val
                            });
                        }}
                    />
                    <div className={'list-content'}>
                        <span className={'title'}>监控设备列表</span>
                        <ul className={'device-list'}>{this.generateDeviceList()}</ul>
                    </div>
                    <div className={'remote-control'}>
                        <span className={'title'}>云台控制</span>
                        <div className={'control-area'}>
                            {/*<div className={'square-control'}>
                            <div className={'outer-square'}></div>
                            <div className={'left'}></div>
                            <div className={'center-square'}></div>
                        </div>*/}
                            <div className={'square-control'}>
                                <div className={'top standard-square'}></div>
                                <div className={'right standard-square'}></div>
                                <div className={'bottom standard-square'}></div>
                                <div className={'left standard-square'}></div>
                                <div className={'center-square'}></div>
                            </div>
                            <div className={'right-control'}>
                                <ul>{this.generateRightOperation()}</ul>
                            </div>
                        </div>
                    </div>
                </aside>
                <section className={'right-display'}>
                    <div className={'camera-area'}>{this.getIframeDom()}</div>
                    <div className={'size-picker'}>{this.generateRightButton()}</div>
                </section>
            </div>
        );
    }
}

export default Monitor;
